import React, { useCallback, useMemo } from 'react'
import { enumToLanguageOptions, supportedLanguages } from '@cbgms/base/translate/locales'
import { useTranslation } from 'react-i18next'
import { Box, Button, Menu, MenuItem } from '@mui/material'
import { LocaleFlag } from './LocaleFlag'

const LocaleSelector: React.FC<{}> = () => {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = useCallback((event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget), [setAnchorEl])
  const handleClose = useCallback(() => setAnchorEl(null), [setAnchorEl])

  // Manually filtered list for only the currently supported main language locales
  const localeOptions = enumToLanguageOptions(supportedLanguages)
  const selectedLanguage = useMemo(
    () => localeOptions.find(o => o.value === i18n.language)?.text || '.....',
    [localeOptions, i18n.language]
  )
  const changeLanguage = useCallback((value: string) => i18n.changeLanguage(value), [i18n])

  return (
    <>
      <Button sx={{ height: '100%' }} color='secondary' data-testid='header-dropdown-locales' onClick={handleClick}>
        <LocaleFlag locale={i18n.language} /> <Box sx={{ paddingLeft: 1 }}>{selectedLanguage}</Box>
      </Button>
      <Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
        {localeOptions.map(option => (
          <MenuItem key={option.value} onClick={() => changeLanguage(option.value)}>
            <LocaleFlag locale={option.value} /> <Box sx={{ paddingLeft: 1 }}>{option.text}</Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default LocaleSelector
